//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"ApproximateSourceHexMeshSize",0,"Expression",0],[0,"CellType",1,0],[0,"CellTypeName",1,0],[0,"CustomUnitCellFile",1,0],[1,"EdgeLength",0,"Expression",0],[0,"IsUniformCube",1,0],[1,"SizeX",0,"Expression",0],[1,"SizeY",0,"Expression",0],[1,"SizeZ",0,"Expression",0],[1,"UnitCellBody",0,"ScCollector",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.UnitCellBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.UnitCellBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.UnitCellBuilder.UnitCellType = Object.freeze({
    "BiTriangle" : "BiTriangle", "TriDiametral" : "TriDiametral", "TriDiametralChevron" : "TriDiametralChevron", "QuadDiametral" : "QuadDiametral", "QuadDiametralLine" : "QuadDiametralLine", "QuadDiametralCross" : "QuadDiametralCross", "Dodecahedron" : "Dodecahedron", "Star" : "Star", "HexStar" : "HexStar", "PseudoSierpinski" : "PseudoSierpinski", "HexVase" : "HexVase", "HexVaseMod" : "HexVaseMod", "Cubeplex" : "Cubeplex", "Octapeak" : "Octapeak", "Octahedroid" : "Octahedroid", "FromFile" : "FromFile", "FromPart" : "FromPart"});

export default SPLM;